import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useEffect } from 'react';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ProfessionistListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (enrollment?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
  type?: string;
}

type Key = {
  codice: string;
};
interface Destinatari {
  codiceComuneResidenza: string;
  key: Key;
}

const ProfessionistListComponent = ({
  disabled,
  onChange,
  value,
  type,
  error,
  label = 'Professionista',
  id = 'professionist-list',
}: ProfessionistListComponentProps): React.ReactElement => {
  const [professionist, getProfessionist] = useHttpFetch<
    HttpResponseList<Destinatari>,
    Array<ItemVM>
  >(`${__PERSON_API_URL__}/persona/destinatari-corrispondenza/professionisti`, {
    onBootstrap: false,
    transformer: (response: AxiosResponse<HttpResponseList<Destinatari>>) => {
      const { data } = response;

      return data?.payload.list.map((item) => ({
        id: item.key.codice,
        value: item.codiceComuneResidenza,
      })) as Array<ItemVM>;
    },
  });

  useEffect(() => {
    if (!type) {
      return;
    }
    getProfessionist({
      url: `/${type}`,
    });
  }, [type]);

  const list = (professionist.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.value}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ProfessionistListComponent.displayName = 'Professionist list component';

const ProfessionistList = memo(ProfessionistListComponent);

export default ProfessionistList as typeof ProfessionistListComponent;
